@if (haveMessages) {
  <app-standard-page>
    @for (alertMessage of getFilteredMessages; track alertMessage) {
      <app-standard-page-content>
        <div class="p-3">
          <div class="row">
            <div class="col-12 col-lg-8">
              @if (alertMessage.header) {
                <h1>{{ alertMessage.header }}</h1>
              }
            </div>
            <div class="col-12 col-lg-4 text-end">
              @if (alertMessage.canDismiss) {
                <a (click)="dismiss(alertMessage.id)" class="btn btn-outline"
                  >Dismiss</a
                >
              }
            </div>
            <div class="col-12 col-lg-8">
              <p class="alert-message-content">
                {{ alertMessage.content }}
              </p>
            </div>
          </div>
        </div>
      </app-standard-page-content>
    }
  </app-standard-page>
}
